import React from 'react';
import { Container, Row } from 'react-bootstrap';
import InputComponent from '../../../components/Input';
import HeaderComponent from '../../LandingPage/Components/Header';
import { uploadFields, vendorInputData } from '../constants';
import useStoreData from '../Hooks/useStoreData';
import { yupResolver } from '@hookform/resolvers/yup';

import styles from '../style.module.scss';
import { schema } from './registerFormSchema';
import { useForm } from 'react-hook-form';
import { FileInput, UploadedMedia } from '../../register/component/supplier/inputMedia';

import Lottie from 'lottie-react';
import loaderAnimation from '../../../lotties/Loader2.json';

const SelfRegisterForm = ({
  selfRegisterDetails,
  onSubmit,
  onChangeSelfRegister,
  handleImage,
  removeImage,
  media,
  callbackLoading,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = '';
  };

  return (
    <div className={`pb-1`}>
      <div className="px-4 d-flex flex-column align-items-center">
        <h3 className="font-weight-bold mt-4 mb-0">Self Registration Form</h3>
        <form className={`d-flex flex-column align-items-center`} onSubmit={handleSubmit(onSubmit)}>
          <div className={`${styles.selfRegisterInputsContainer}`}>
            {vendorInputData.map((data) => {
              return (
                <div className={`mt-3 ${styles.businessInputContainer}`}>
                  {selfRegisterDetails[data.name] && <span>{data.title}</span>}
                  <InputComponent
                    type={data.type}
                    //   disabled={callbackLoading ? true : false}
                    className={`${styles.businessInputBox} bg-white`}
                    value={selfRegisterDetails[data.name]}
                    placeholder={data.title}
                    name={data.name}
                    ref={register(data.name).ref}
                    handleChange={(e) => {
                      setValue(data.name, e.target.value, { shouldValidate: true });
                      onChangeSelfRegister(e);
                    }}
                    // {...register(data.name)}
                    error={errors[data.name]?.message}
                  />
                </div>
              );
            })}
            {/* <div className={`mt-2 ${styles.businessInputContainer}`}>
            </div> */}
          </div>
          <div className={`${styles.selfRegisterInputsContainer}`}>
            {uploadFields.map((field) => {
              return (
                <div className={`mt-3 ${styles.uploadFileContainer}`}>
                  <UploadedMedia
                    removeImage={removeImage}
                    name={field?.name}
                    source={media && media[field?.name]}
                  />
                  <FileInput
                    handleImage={(e) => handleImage(e, field?.name)}
                    name={field?.name}
                    placeholder={field?.placeholder}
                    handleClick={handleClick}
                    className={`${styles.businessInputBox} bg-white`}
                  />
                </div>
              );
            })}
          </div>
          {callbackLoading && (
            <Lottie
              className={`${styles.loaderAnimation} mt-3`}
              animationData={loaderAnimation}
              loop={true}
            />
          )}
          <button
            disabled={callbackLoading ? true : false}
            type="submit"
            // className={`mt-4 ${1 === 1 ? styles.enabledSubmit : styles.disabledSubmit}`}
            className={`mt-4 ${callbackLoading ? styles.disabledSubmit : styles.enabledSubmit}`}
          >
            <span>Submit</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default SelfRegisterForm;
